"use client";

import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import {
  symfonyFaqs,
  symfonyHeroData,
  symfonyStatsData,
  symfonySolutionsAndProcessData,
  symfonyPortfolioData,
  symfonyTechnologiesData,
  symfonyAboutData,
} from "src/utils/mock/symfonyAppData";
import { caseStudies } from "src/utils/mock/caseStudies";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function SymfonyDevelopment({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const symfonyProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";
    const webApp = project.platforms?.toLowerCase().includes("web") || project.platforms?.toLowerCase().includes("mobile");

    // const hasSymfonyTech = project.technologies?.some((tech) => tech.name?.toLowerCase().includes("symfony"));
    const hasSymfonyTech = true;

    return isActive && webApp && hasSymfonyTech;
  });

  const filteredData = {
    ...symfonyPortfolioData,
    projects: {
      liveProjects: symfonyProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={symfonyHeroData} />

      <TechStats stats={symfonyStatsData} />

      <WhyChooseUs data={symfonySolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />

          <ProcessStepsSection data={symfonyTechnologiesData} techIcons={techIcons} />

          <TechsSection sections={symfonyAboutData} mainTitle="About Symfony Development" />
        </div>
      </section>

      <FAQSection faqs={symfonyFaqs} />
      <CommonContactSection />
    </div>
  );
}
